var map = {
	"./avatar.png": "4d41",
	"./discord.svg": "7d6d",
	"./google.svg": "b5df",
	"./lang_cn.svg": "316c",
	"./lang_en.svg": "61fe",
	"./logo.svg": "e347",
	"./logo_square.png": "c670",
	"./nowire.svg": "bb30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e5b";